/**
 * @file This is a dumping ground for types that do not fit neatly into other places
 * We should periodically review this file and move types to more appropriate locations.
 */

export type ProjectType = {
  id: number;
  name: string;
};

/** TODO: move to constants */
export enum DaysOfWeek {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}
